/* eslint-disable react/jsx-pascal-case */
import ArgonTypography from 'components/ArgonTypography';
import { getMenuItem } from 'global/func';
import { MRT_ShowHideColumnsButton, MRT_ToggleDensePaddingButton, MRT_ToggleFullScreenButton, MRT_ToggleGlobalFilterButton, MaterialReactTable } from 'material-react-table';
import { useMemo } from 'react';

const TabelPerencanaan = ({
    handleOpenAddChild,
    setParentData,
    setEditData,
    handleOpenEdit,
    loading,
    data,
    deleteData,
    opd,
    baseUrl,
    allowEdit=true
}) => {

    const columns = useMemo(() => ([
        {
            accessorKey: 'kode',
            header: 'Kode',
            size: 45,
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    fontSize="small"
                    variant="inherit"
                    // color={cell.row.original.childAnggaran !== cell.row.original.anggaran ? 'error' : 'inherit'}
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'uraian',
            header: 'Uraian',
            size: 500,
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    fontSize="small"
                    variant="inherit"
                    // color={cell.row.original.childAnggaran !== cell.row.original.anggaran ? 'error' : 'inherit'}
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontWeight={(cell.row.original.ket === 'PROGRAM' || cell.row.original.ket === 'KEGIATAN') && 'bold'}
                    color={cell.row.original.childAnggaran !== cell.row.original.anggaran ? 'error' : 'inherit'}
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        cell.getValue() === 0 ? ' ' : cell.getValue()?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [data])

    return (
        <>
            <MaterialReactTable
                columns={columns}
                data={data}
                enableExpanding
                enableExpandAll
                muiTableHeadCellProps={{
                    sx: {
                        fontSize: '0.875rem !important',
                        color: 'text.main !important'
                    }
                }}
                muiTableFooterCellProps={{
                    sx: {
                        fontSize: '0.875rem !important',
                        color: 'text.main !important'
                    }
                }}
                muiTopToolbarProps={{
                    sx: { fontSize: '0.875rem' }
                }}
                initialState={{
                    expanded: true
                }}
                enablePagination={false}
                enableColumnFilters={false}
                renderToolbarInternalActions={({ table }) => (
                    <>
                        <MRT_ToggleGlobalFilterButton table={table} color='text' />
                        <MRT_ShowHideColumnsButton table={table} color='text' />
                        <MRT_ToggleFullScreenButton table={table} color='text' />
                        <MRT_ToggleDensePaddingButton table={table} color='text' />
                    </>
                )}
                enableSorting={false}
                state={{ isLoading: loading }}
                enableRowActions={true}
                positionActionsColumn='first'
                renderRowActionMenuItems={({ closeMenu, row }) =>
                    getMenuItem(row.original, closeMenu, handleOpenAddChild, setParentData, setEditData, handleOpenEdit, deleteData, opd, baseUrl, allowEdit)
                }
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: 'Action', //change header text
                        size: 50, //make actions column wider
                        alignment: 'left'
                    },
                }}
            />
        </>
    )
}

export default TabelPerencanaan